<template>
  <ShipmentsFeed />
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from 'vue'

export default defineComponent({
  name: 'ShipmentsFeedPage',
  components: {
    ShipmentsFeed: defineAsyncComponent(() => import('@/views/Components/Shipments/ShipmentsFeed.vue')),
  },
})
</script>
